import { Checkbox, Error, IconSizes } from "@brexhq/component-library";
import { Text } from "@brexhq/metal-text";
import styled from "@emotion/styled";
import React from "react";

import { BodyText } from "@brexhq/next/src/components/deprecated/Typography";
import { Container } from "@brexhq/next/src/components/layout/Container/Container";

import { CheckboxOptionValues } from "../types";

const ErrorIconWrapper = styled.div(({ theme }) => ({
  color: theme.colors.negative.default,
  paddingRight: theme.spacing.p8,
}));

const CheckBoxWrapper = styled.div(({ theme }) => ({
  display: "flex",
  [theme.breakpoints.SML]: {
    gap: ".75rem",
  },
  flexDirection: "column",
}));

const FieldLabel = styled(Text)(({ theme }) => ({
  paddingBottom: theme.spacing[16],
  color: theme.colors.content.primary,
}));

type CheckboxListProps = {
  label: string;
  onChange: (params: {
    name: string;
    value: string[];
    checkBox: CheckboxOptionValues;
  }) => void;
  name: string;
  value: string[];
  options: Array<CheckboxOptionValues>;
  error: React.ReactNode;
};

export const CheckboxList: React.FC<CheckboxListProps> = ({
  label,
  onChange,
  name,
  value,
  options,
  error,
}) => {
  return (
    <Container
      alignItems={"flex-start"}
      justifyContent={"flex-end"}
      direction={{ LRG: "column", MED: "column", SML: "column" }}
    >
      <FieldLabel variant="BodySmallM">{label}</FieldLabel>
      <CheckBoxWrapper>
        {options.map((checkBox: CheckboxOptionValues) => (
          <Checkbox
            key={checkBox.label}
            label={checkBox.label}
            name={checkBox.value}
            value={value.includes(checkBox.value)}
            onChange={() => {
              onChange({ name, value, checkBox });
            }}
          />
        ))}
      </CheckBoxWrapper>
      <BodyText textModifier="MICRO_LIGHT">
        <Container justifyContent={"flex-start"} alignItems={"center"}>
          {error && (
            <ErrorIconWrapper>
              <Error size={IconSizes.SMALL} />
            </ErrorIconWrapper>
          )}
          {error}
        </Container>
      </BodyText>
    </Container>
  );
};
